import cn from 'classnames';
import dayjs from 'dayjs';
import { FC } from 'react';
import { IoWarningOutline } from 'react-icons/io5';
import { useManagerStore } from '../../../../../../../store/use-manager-store';
import { getShiftStatus, ShiftCellType } from '../shifts-helpers';
import s from './shifts-grid-monthly.module.css';
import { StatusIcon } from './status';

export const ShiftsGridMonthly: FC<ShiftCellType> = (props) => {
  const { employee, date, className, onClick } = props;
  const { hasAccess } = useManagerStore();
  const isAllowed = hasAccess('staff', ['write']);

  const shifts = employee?.shifts || [];

  const shift = shifts?.find((shift) => {
    const startTime = dayjs(shift.start_time);
    const currentDate = dayjs(date);

    return startTime.isSame(currentDate, 'day');
  });

  const status = props.status || getShiftStatus(shift);
  if (!status) return null;

  const states = status.split('-');
  const isShiftExist = states.includes('green') || states.includes('red');

  return (
    <div
      className={cn(s.feature, s[status], className, isAllowed && s.clickable)}
      onClick={isAllowed ? () => onClick?.(shift ? [shift] : [], employee, date) : undefined}
    >
      {isShiftExist && <StatusIcon income={states[0]} outcome={states[1]} />}
      {status === 'absent' && <IoWarningOutline color="#FF6262" />}
    </div>
  );
};
